import { featureFlags } from '@/env';
import {
  allowedReservationActions,
  type ReservationAction,
} from '@/features/reservations/model/reservation-actions';
import { getDateContext } from '@/utils/status';
import type { Reservation } from '@restaurant/api-client';

export function allowedActionsForReservation(
  reservation: Reservation | null,
): ReadonlySet<ReservationAction> {
  if (!reservation) return new Set();

  return allowedReservationActions({
    status: reservation.status,
    arrivalStatus: reservation.arrivalStatus,
    dateContext: getDateContext(reservation.time),
    seatedAndInProgressEnabled: featureFlags.seatedAndInProgress,
    rescheduleEnabled: featureFlags.reschedule,
  });
}
